import * as React from 'react'
import { Container } from 'typescript-ioc/es5'
import { NotificationService } from '../../services'
import { NotificationDto } from '../../features/notifications'
import { PromiseableProp } from '../../_utils/promiseable-prop'
import { ApiVersion } from '../../enums/api-version.enum'

interface INotificationsLoader {
    domainId: number
    notifId?: number
    testId?: number
    children: (notifications: PromiseableProp<NotificationDto[] | undefined>) => JSX.Element
}

const NotificationsLoader = ({ domainId, notifId, testId, children }: INotificationsLoader) => {
    const notifService = Container.get(NotificationService)

    const loadData = async (): Promise<NotificationDto[] | undefined> => {
        const notifs: any = []

        if (notifId) {
            const notification = await notifService.fetchNotificationById(domainId, notifId, {
                query: { includeSchedules: true },
                cancellationKey: `nl-n${notifId}`,
                version: ApiVersion.V4,
            })
            if (!!notification) {
                if (!testId) {
                    delete notification.abTest

                    notifs.push(notification)
                } else {
                    const { notifications, schedules, ...test } = (await notifService.fetchTestById(
                        domainId,
                        testId,
                        undefined,
                        `nl-t${testId}`,
                    )) as any

                    notifications.forEach((n) => {
                        const notif = NotificationDto.parse(n)
                        notif.audience = notification?.audience! ?? {}
                        notif.abTest = {
                            ...(notif.abTest ?? {}),
                            ...test,
                        }

                        const schedule = schedules.find((s) => s.notificationId.toString() === n.id.toString())
                        if (schedule) {
                            notif.status = schedule.status ?? notif.status
                            notif.deliverySpec = {
                                ...schedule.deliverySpec,
                                ...notif.deliverySpec,
                            }
                        }

                        notifs.push(notif)
                    })
                }
            }
        }

        return notifs.length ? notifs : undefined
    }

    return children(loadData())
}

export default React.memo(NotificationsLoader, () => true)
